import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from "./router/index.js"
import "swiper/css/swiper.css";
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import { Pagination } from 'element-ui';
Vue.use(ElementUI);
Vue.use(VideoPlayer)
Vue.component(Pagination.name, Pagination);

// new Vue({
// 	el: '#app',
// 	render: h => h(App),
// 	router
// });

Vue.config.productionTip = false

new Vue({
	render: h => h(App),
	router
}).$mount('#app')